<template>
    <div>
        <div v-if="!response" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div v-for="(choice, index) in question.max"
            :key="index"
            :class="['choice', 'select-choice', { selected: response != null && response.hasOwnProperty(choice - 1) }]">
            {{ question.label[choice - 1] ? question.label[choice - 1] : choice }}
        </div>
    </div>
</template>

<script>

export default {   
    name: 'scroller-partial',

    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: Object,
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
